import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {AnalyticsService} from "../services/analytics.service";
import * as _ from 'lodash';
import {ROUTES_PATHS} from "../const/routes";
import {RENOVATION_MAP, RenovationKey} from "../const/renovation-type";
import {RenovationType} from "../Models/RenovationType";
import {RenovationTypesList} from "../const/renovation-types-list";

@Component({
	selector: 'app-choix-renov-bis',
	templateUrl: './choix-renov-bis.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./choix-renov-bis.component.less']
})
export class ChoixRenovBisComponent implements OnInit {
	textes: any = "";
	globalTxt: any = "";
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	token: any = JSON.parse(localStorage.getItem("token")!);
	listTypeRenovations: RenovationType[] = [];

	constructor(
		public app: AppComponent,
		public analyticsService: AnalyticsService
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					// Filter the renovation types based on the token refId
					let company: string = this.app.sharedToolsService.returnObjectSwitchRefId();
					let renovationTypesListFiltered = _.filter(RenovationTypesList, (o) => {
						return o.showInRefs.includes(company);
					});
					this.listTypeRenovations = renovationTypesListFiltered;
				});
		});
	}

	goToBatiment(opt: any, index: number) {
		console.log("option choisie : ", opt);

		this.batiment.typeRenovationBis = opt.label;
		localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));

		const renovationKey: RenovationKey = opt.code as RenovationKey;
		let renovation: string = RENOVATION_MAP[renovationKey] ?? "";

		if (renovation == "") {
			console.warn("renovation is empty", renovation);
			return;
		}

		localStorage.setItem("RENOVATION", renovation);

		// Tracking Analytics: Type renovation
		this.analyticsService.trackEvent('user_interaction', 'click_type_renovation', 'value : renovation ' + renovation);

		this.app.router.navigate([ROUTES_PATHS.BATIMENT]);
	}
}
